import { MOBILE_TYPES } from "@/util/mobile.type";

export const sendHeadersToMobile = {
  methods: {
    sendHeadersToMobile(barcode, password, readyToPick) {
      if (this.isMobile) {
        if (this.platform == MOBILE_TYPES.ANDROID) {
          window.PacketaPPA.sendHeaders(barcode, password, readyToPick);
        } else if (this.platform == MOBILE_TYPES.IOS) {
          window.webkit.messageHandlers.sendHeaders.postMessage({
            barcode: barcode,
            readyToPick: readyToPick
          });
        }
      }
    }
  }
};
